/*
 * Analytics — GA4 uniquement, conditionné au consentement (Sprint C2).
 *
 * - Charge dynamiquement GA4 (G-ZL4C3KL77Z) UNIQUEMENT si l'utilisateur a
 *   accepté la catégorie "analytics" dans la bannière de cookies.
 * - Émet automatiquement un événement `page_view` à chaque changement de route.
 * - Les autres exports (Meta Pixel) restent no-op tant que non activés.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, trackPageview, trackEvent as gaTrackEvent } from '../utils/analytics';

let initialized = false;

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (!initialized) {
      initAnalytics();
      initialized = true;
    }
  }, []);

  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location.pathname, location.search]);
};

export const trackEvent = gaTrackEvent;

// Meta Pixel : intentionnellement no-op (l'utilisateur a demandé "skip meta").
const NOOP = () => {};
export const initMetaPixel = NOOP;
export const trackLead = NOOP;
export const trackPurchase = NOOP;
export const trackViewContent = NOOP;
export const trackInitiateCheckout = NOOP;
export const trackBooking = NOOP;
export const trackContact = NOOP;
export const trackWhatsApp = NOOP;
